// List-preview ordering is distinct from a command's delivery lifecycle.
// pending/sending are existing local optimistic labels, not new API values.
const RANK = Object.freeze({ pending: 0, sending: 0, queued: 0, processing: 0, submitted: 0,
  sent: 1, failed: 1, delivered: 2, read: 3 });
const valid = status => Object.hasOwn(RANK, status) ? status : null;

export function advanceLastMessageStatus(previous, incoming) {
  const before = valid(previous), after = valid(incoming);
  if (after == null) return before;
  return before != null && RANK[before] > RANK[after] ? before : after;
}

// A read tick belongs to one message, never to its conversation in general.
export function mergeLastMessageStatus(previous, incoming) {
  if (!incoming?.id || incoming.id !== previous?.id || incoming.direction !== 'outbound') return incoming;
  if (previous.status === undefined && incoming.status === undefined) return incoming;
  return { ...incoming, status: advanceLastMessageStatus(previous.status, incoming.status) };
}
